export default __webpack_public_path__ + "static/media/clear.7e4cf9ca.svg";